import { IS_BROWSER, APPConfig } from 'config/appConfig'
import React from 'react'

async function getGoogleCaptchaToken(props) {
  const { googleCaptchaId } = props || {}
  const token = await window?.grecaptcha?.enterprise?.execute(googleCaptchaId, {
    action: 'verify',
  })
  return token
}

class GoogleCaptcha extends React.Component {
  componentDidMount() {
    if (IS_BROWSER) {
      const script = document.createElement('script')
      const googleCaptchaId = APPConfig.getAppConfig()?.googleCaptchaId
      script.src = `https://www.google.com/recaptcha/enterprise.js?render=${googleCaptchaId}`
      script.async = true
      script.defer = true
      script.onload = this.loadGoogleCaptchaScript
      document.head.appendChild(script)
    }
  }

  loadGoogleCaptchaScript = () => {
    const { googleCaptchaId } = APPConfig.getAppConfig()
    if (IS_BROWSER) {
      window.grecaptcha.enterprise.ready(async () => {
        await getGoogleCaptchaToken({ googleCaptchaId })
      })
    }
  }

  render() {
    return ''
  }
}

export default GoogleCaptcha
export { GoogleCaptcha, getGoogleCaptchaToken }
